export const classes = {
  card: 'relative z-10 flex flex-col items-center gap-[30px] w-[360px] max-w-[calc(100%-40px)] pt-[38px] px-8 pb-[26px] rounded-[26px] border border-solid border-white/70 bg-[linear-gradient(160deg,rgba(255,255,255,0.55),rgba(255,255,255,0.32))] shadow-[0_32px_80px_-28px_rgba(70,60,90,0.4),inset_0_1px_0_rgba(255,255,255,0.6)] backdrop-blur-[28px] animate-[cardIn_0.5s_cubic-bezier(0.2,0.8,0.2,1)_both]',
  spinner: 'relative size-[100px] place-center',
  ring: 'absolute inset-0 rounded-full border-[2.5px] border-solid border-brand-accent/[0.14] border-t-brand-accent border-r-[#f5834f] animate-spin',
  logoTile:
    'size-[70px] place-center rounded-full p-[11px] bg-grad shadow-[0_10px_22px_-8px_rgba(241,90,43,0.55)]',
  logo: 'block w-[42px] h-auto',
  text: 'flex items-end gap-[3px] text-[15.5px] font-medium text-[#5a5b60]',
};
